export default "__VITE_ASSET__psTTJWQe__"